module.exports = __webpack_public_path__ + "img/doge.2182cc82.png";